import classNames from 'classnames'
import { observer } from 'mobx-react'
import GlobalState, {
  changeMenuState,
  changeLocaleState,
} from '../../stores/GlobalState'
import global from '../../assets/globe.svg' //{ ReactComponent as Global }
import './index.scss'
import { Fragment, useEffect } from 'react'
import ContentState from '../../stores/ContentState'
import { useLocation } from 'react-router'
const Menu = observer(() => {
  const { pathname } = useLocation()

  useEffect(() => {
    if (GlobalState.isMenuOpen) {
      document.querySelector('body, html, #root')?.classList.add('hidden-menu')
    } else
      document
        .querySelector('body, html, #root')
        ?.classList.remove('hidden-menu')
  }, [GlobalState.isMenuOpen])

  let lang = GlobalState.currentLocale.lang.includes('En')
    ? '/en'
    : GlobalState.currentLocale.lang.includes('ру')
    ? '/ru'
    : ''
  return (
    <section
      className={classNames('menu', GlobalState.isMenuOpen && 'open')}
      onClick={() => changeMenuState()}
    >
      <div
        className="menu__container main"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="menu__top">
          <div className="menu__top-left">
            <div className="menu__locale" onClick={changeLocaleState}>
              <img src={global} />
              {/* <Global /> */}
              <div className="menu__locale-block">
                <div className="menu__locale-top">
                  {GlobalState.currentLocale.country}
                </div>
                <div className="menu__locale-bottom">
                  {GlobalState.currentLocale.lang}
                </div>
              </div>
            </div>
          </div>
          <div className="menu__close" onClick={changeMenuState}>
            <div className="menu__close-dash"></div>
            <div className="menu__close-dash"></div>
          </div>
        </div>
        <div className="menu__list">
          {ContentState.subMenu?.list?.map((l, i) => {
            let newLink = l.link,
              forYouLink = ContentState.subMenu?.foryouLink || '',
              forBusinessLink = ContentState.subMenu?.forbusinessLink || ''
            if (!l.link.includes('https://')) {
              if (
              document.referrer.includes('novaposhtaglobal') &&
              !document.referrer.includes('personal') &&
              !l.link.includes('/login')
            ) {
              newLink = 'https://novaposhtaglobal.ua' + l.link
              forYouLink = 'https://novaposhtaglobal.ua' + forYouLink
              forBusinessLink = 'https://novaposhtaglobal.ua' + forBusinessLink
              } else if (document.referrer.includes('nova.global')) {

                const basicUrl = GlobalState.currentLocale.lang.includes('En')?'en-ua/':GlobalState.currentLocale.lang.includes('ру')?'ru-ua/':'ua-ua/';
                
                newLink = `https://nova.global/${basicUrl}${newLink.replaceAll('en/', '').replaceAll('ru/', '').replaceAll('/', '')}`
                forYouLink = `https://nova.global/${basicUrl}${forYouLink.replaceAll('en/', '').replaceAll('ru/', '').replaceAll('/', '')}`
                forBusinessLink = `https://nova.global/${basicUrl}${forBusinessLink.replaceAll('en/', '').replaceAll('ru/', '').replaceAll('/', '')}`
              } else {
              newLink = !l.link.includes('/login')
                ? `${l.link.includes('http') ? '' : lang}${l.link}`
                : `${lang}/login/`
              }
              

            }

            return (
              <Fragment key={i}>
                <a
                  className={classNames(
                    'menu__item',
                    window.location.href.includes(l.link.trim()) && 'active',
                    l.link.includes('#') && 'disable-link',
                  )}
                  href={newLink}
                  target={l.link.includes('http') ? '__blank' : ''}
                  onClick={() => {
                    changeMenuState()
                  }}
                >
                  <span> {l.title}</span>
                </a>
                {l.link.includes('services') ? (
                  <div className="menu__sub-list">
                    <div className="menu__sub-row">
                      <a
                        href={forYouLink}
                        className={classNames(
                          'menu__sub-text',
                          window.location.href.includes(
                            ContentState.subMenu!.foryouLink?.trim(),
                          ) && 'active',
                        )}
                      >
                        <span>{ContentState.subMenu?.foryou}</span>
                      </a>
                      <a
                        className={classNames(
                          'menu__sub-text',
                          window.location.href.includes(
                            ContentState.subMenu!.forbusinessLink?.trim(),
                          ) && 'active',
                        )}
                        href={forBusinessLink}
                      >
                        <span>{ContentState.subMenu?.forbusiness}</span>
                      </a>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </Fragment>
            )
          })}
        </div>
      </div>
    </section>
  )
})

export default Menu
